import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { GTMProvider, useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { jsx as _jsx } from "react/jsx-runtime";

function TagManager(_ref) {
  var params = _ref.params,
      id = _ref.id,
      environment = _ref.environment,
      dataLayer = _ref.dataLayer,
      children = _ref.children;

  var config = _objectSpread(_objectSpread({
    id: id
  }, environment && environment.gtm_auth && environment.gtm_preview && {
    environment: environment
  }), dataLayer && {
    dataLayer: dataLayer
  });

  return _jsx(GTMProvider, {
    state: params !== null && params !== void 0 ? params : config,
    children: children
  });
}

TagManager.dispatch = useGTMDispatch;
TagManager.displayName = 'TagManager';
export default TagManager;